import { handleValid, Input } from 'components'
import { TabMyOrganizationItem } from 'interfaces'
import get from 'lodash/get'
import React, { useEffect } from 'react'
import { Path } from 'react-hook-form'
import { configGenaral } from 'utils'
import { PropsComponentsMyOrganization } from './interfaceSlide.type'

export const SlideTitle: React.FC<PropsComponentsMyOrganization> = ({
	pos,
	errors,
	register,
	setValue,
	watch,
	isValid,
	setFieldError,
	name
}): JSX.Element => {
	const errorTitle = get(errors, `${name}.${pos}.component_value.title`)
	const errorField = !!errorTitle
	const rules = {
		title: {
			required: { value: true, message: 'This field is required' }
		}
	}

	const nameType = `title-${name}-${pos}`

	useEffect(() => {
		handleValid(nameType, !errorField as boolean, setFieldError)
		return () => {
			const titleField = watch(
				`${name}.${pos}.component_value.title` as Path<{
					tabs: TabMyOrganizationItem[]
				}>
			)
			if (!titleField) {
				handleValid(nameType, false, setFieldError)
			}
		}
	}, [isValid, errorTitle])

	const fieldName = `${name}.${pos}.component_value.title` as Path<{
		tabs: TabMyOrganizationItem[]
	}>
	return (
		<div className=" w-full pb-1">
			<Input
				name={`${name}.${pos}.component_value.title`}
				title="Title"
				register={register}
				rules={rules.title}
				error={errorTitle}
				borderFull
				limit
				cantLimit={configGenaral.maxTitleLength}
				watchValue={String(watch(fieldName) ?? '')}
				setValueInput={setValue}
				placeholder="Add a title"
			/>
		</div>
	)
}
